import { render, staticRenderFns } from "./TableProduct.vue?vue&type=template&id=cf81e3ce&"
import script from "./TableProduct.vue?vue&type=script&lang=js&"
export * from "./TableProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports